import cn from 'classnames'
import Link from 'next/link'
import React, { memo } from 'react'

import styles from './SignUp.module.css'

interface Params {
  currentStep?: number
}

export const SignUpBottom: React.FC<Params> = memo(({ currentStep = 1 }) => {
  return (
    <>
      <div className={'flex flex-row'}>
        <span className={cn(styles.haveAnAccountSig, 'mr-[5px]')}>Have an account?</span>
        <Link href="/signin" className={cn(styles.haveAnAccountSig, 'font-bold underline cursor-pointer')}>
          Sign In
        </Link>
      </div>
      {currentStep === 1 && (
        <div className="flex flex-row mt-[10px]">
          {/* <span className={cn(styles.haveAnAccountSig, 'mr-[5px]')}>Are you a vendor?</span>
          <Link href={'/requestvendor'} className={cn(styles.haveAnAccountSig, 'font-bold underline cursor-pointer')}>
            Vendor Information
          </Link> */}
        </div>
      )}
    </>
  )
})
